module.exports = __webpack_public_path__ + "img/atv-track-3.07d2f9f8.jpg";